import {combineReducers} from 'redux';

import * as actions from './installments-report-action';
import type {InstallmentsReportApiResponse} from './installments-report-api';

type SummaryState = {
    hasError: boolean;
    isLoading: boolean;
    data: InstallmentsReportApiResponse | null;
    errorMessage: string | undefined;
};

const defaultSummaryState: SummaryState = {
    data: null,
    hasError: false,
    isLoading: true,
    errorMessage: undefined,
};

function errorMessageFromPayload(payload: unknown): string {
    if (payload && typeof payload === 'object' && 'message' in payload) {
        const msg = (payload as {message?: unknown}).message;
        if (typeof msg === 'string' && msg.length > 0) {
            return msg;
        }
    }
    return 'Failed to load installments report.';
}

export const summaryReducer = (
    state: SummaryState | undefined,
    action: actions.InstallmentsReportAction
): SummaryState => {
    const s = state ?? defaultSummaryState;
    switch (action.type) {
        case actions.ActionTypes.INSTALLMENTS_REPORT_FETCH_REQUEST:
            return {
                data: s.data,
                isLoading: true,
                hasError: false,
                errorMessage: undefined,
            };
        case actions.ActionTypes.INSTALLMENTS_REPORT_FETCH_SUCCESS:
            return {
                data: action.payload,
                isLoading: false,
                hasError: false,
                errorMessage: undefined,
            };
        case actions.ActionTypes.INSTALLMENTS_REPORT_FETCH_FAILURE:
            return {
                data: s.data,
                isLoading: false,
                hasError: true,
                errorMessage: errorMessageFromPayload(action.payload),
            };
        default: {
            return s;
        }
    }
};

export const installmentsReportReducer = combineReducers({
    summary: summaryReducer,
});

export type InstallmentsReportState = {
    summary: SummaryState;
};
